(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentAlertsCategoryHeader', function() {
      return {
        restrict: 'E',
        scope: {
          edxCategoryLabel: '=',
          edxCategoryDescription: '=',
          edxCategoryIcon: '='
        },
        templateUrl: '/resources/components/report/classroom/at-a-glance/student-alerts-category-header.directive.html',
        controller: [StudentAlertsTableController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function StudentAlertsTableController() {
    var vm = this;
    _onInit();

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _onInit() {
    }

  }

})();